import React, { useState } from 'react';
import { Tree } from 'primereact/tree';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';

// eslint-disable-next-line import/no-unresolved
import { treeNodes, treeTableNodes } from '@constants/dummy';

const TreeDemo = () => {
  const [selectedTreeNodeKeys, setSelectedTreeNodeKeys] = useState(null);
  const [selectedTreeTableNodeKeys, setSelectedTreeTableNodeKeys] = useState(
    []
  );

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="card">
          <h5>Tree</h5>
          <Tree
            value={treeNodes}
            selectionMode="checkbox"
            selectionKeys={selectedTreeNodeKeys}
            onSelectionChange={(e) => setSelectedTreeNodeKeys(e.value)}
          />
        </div>
      </div>
      <div className="p-col-12">
        <div className="card">
          <h5>TreeTable</h5>
          <TreeTable
            value={treeTableNodes}
            header="FileSystem"
            selectionMode="checkbox"
            selectionKeys={selectedTreeTableNodeKeys}
            onSelectionChange={(e) => setSelectedTreeTableNodeKeys(e.value)}
          >
            <Column field="name" header="Name" expander />
            <Column field="size" header="Size" />
            <Column field="type" header="Type" />
          </TreeTable>
        </div>
      </div>
    </div>
  );
};
export default TreeDemo;
